export const enum ActionType {
  setCart = "SET_CART",
  setAddresses = "SET_ADDRESSES",
  setLocation = "SET_LOCATION",
  setApp = "SET_APP",
}

export const enum OrderType {
  delivery = "delivery",
  pickup = "pickup",
}

export const enum OrderStatus {
  pending = "pending",
  preparing = "preparing",
  completed = "completed",
  dispatched = "dispatched",
  cancelled = "cancelled",
}

const Enums = {
  details: (value: OrderStatus | string) =>
    ({
      [OrderStatus.pending]: { name: "Pending", step: 0, color: "#1890ff" },
      [OrderStatus.preparing]: {
        name: "In-Process",
        step: 1,
        color: "#faad14",
      },
      [OrderStatus.dispatched]: {
        name: "Dispatched",
        step: 2,
        color: "#13c2c2",
      },
      [OrderStatus.completed]: { name: "Complete", step: 3, color: "#5CB338" },
      [OrderStatus.cancelled]: { name: "Cancel", step: 4, color: "#ff4d4f" },
    }[value as OrderStatus]),
  nextStatus: (status: string) =>
    (
      ({
        pending: "preparing",
        preparing: "dispatched",
        dispatched: "completed",
      }) as Record<string, string>
    )[status],
};

export default Enums;
